import { CircularProgress, Typography } from "@mui/material"
import React from "react"

interface IColorizedTextProps {
  disabled: boolean
  isLoading: boolean
  text: string
  difference: number
  isCreationForm: boolean
  id?: string
}

export const ColorizedText = React.memo(
  ({ text, id, difference, isLoading, disabled, isCreationForm }: IColorizedTextProps) =>
    isLoading ? (
      <CircularProgress
        id={id ? `${id}-loading` : undefined}
        sx={{ color: theme => theme.palette.primary.main, width: "1rem" }}
        size="20"
      />
    ) : (
      <Typography
        id={id || undefined}
        fontSize=".8rem"
        sx={{
          whiteSpace: "nowrap",
          color: theme =>
            disabled
              ? theme.palette.text.secondary
              : difference === 0 || isCreationForm
                ? theme.palette.text.primary
                : difference > 0
                  ? "#00bb00"
                  : "#f95050"
        }}>
        {text}
      </Typography>
    )
)
